import Layout from "@/layout";
import { getRolesForRoute } from "@/utils/roles";

const getRoutes = () => {
  return [
    // {
    //   path: "/audit",
    //   component: Layout,
    //   children: [
    //     {
    //       path: "",
    //       name: "audit",
    //       component: () => import("@/modules/audit/views/Audits.vue"),
    //       meta: {
    //         title: "Auditoría",
    //         roles: [...getRolesForRoute("audit")],
    //       },
    //     },
    //   ],
    // },
  ];
};

export default getRoutes;
